import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-293">
      <div className="flex items-center gap-4 mb-6" data-id="element-294">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-295">
          {initials}
        </div>
        <div data-id="element-296">
          <div className="font-bold text-white" data-id="element-297">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-298">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-299">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-300" />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-301">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-302">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'VG',
    name: 'Viviana G.',
    location: 'Buenos Aires',
    quote: 'Tres años yendo al médico y ninguno me dijo lo que este sistema me explicó en el primer tomo. En 10 días dejé de despertar inflamada.'
  }, {
    initials: 'RM',
    name: 'Rosa M.',
    location: 'Córdoba',
    quote: 'Todo se consigue en la verdulería del barrio. Nada raro, nada importado. Y funciona de verdad.'
  }, {
    initials: 'EP',
    name: 'Elena P.',
    location: 'Rosario',
    quote: 'Empecé a leerlo por curiosidad profesional. Al día 6 ya lo estaba aplicando yo misma.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-303">
      <div className="container mx-auto px-4" data-id="element-304">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-305">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-306" />)}
        </div>
      </div>
    </section>;
}